import React from 'react';

const Footer = () => {
    return (
        <footer className="app-footer" style={{ textAlign: 'center', padding: '20px', borderTop: '1px solid var(--border-color)', marginTop: '40px' }}>
            <p style={{ margin: 0, fontWeight: '500', color: 'var(--text-color-secondary)' }}>
                © {new Date().getFullYear()} <a href="https://searchisend.in/" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary-orange)', textDecoration: 'none', fontWeight: '700' }}>Search is End!</a>. All rights reserved.
            </p>
            <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', gap: '20px', fontSize: '0.9em' }}>
                <a href="/privacy" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--text-color-secondary)', textDecoration: 'none' }}>Privacy Policy</a>
                <a href="/terms" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--text-color-secondary)', textDecoration: 'none' }}>Terms & Conditions</a>
                <a href="/refund-policy" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--text-color-secondary)', textDecoration: 'none' }}>Refund Policy</a>
            </div>
            <p style={{ margin: '15px 0 0 0', fontSize: '0.85em', color: 'var(--text-color-secondary)' }}>
                <a href="/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit', display: 'inline-flex', alignItems: 'center', gap: '4px', opacity: 0.8 }} onMouseEnter={(e) => e.currentTarget.style.opacity = 1} onMouseLeave={(e) => e.currentTarget.style.opacity = 0.8}>
                    Powered by <strong style={{ color: 'var(--primary-orange)' }}>SIE QR Menu</strong>
                </a>
            </p>
        </footer>
    );
};

export default Footer;